import { fork } from 'redux-saga/effects';
import { templatesWatcher } from './templatesSaga';
import { templateCardWatcher } from './templateCardSaga';

export default function* Templates() {
  yield fork(templatesWatcher);
  yield fork(templateCardWatcher);
}
